const allowedDomains = [
  'external.t-mobile.pl',
  't-mobile.pl',
  'eu.telekom.com',
  'external.eu.telekom.com',
  'ext.telekom.hu',
  'flip.hu',
  'partner.telekom.hu',
  'telekom.hu',
  'uzleti.telekom.hu',
  'external.telekom.sk',
  'external.t-mobile.cz',
  'obchod.t-mobile.cz',
  'osobne.t-mobile.cz',
  'predajna.telekom.sk',
  'presales.t-mobile.cz',
  'prodejna.t-mobile.cz',
  'telekom.sk',
  'telekom-infra.sk',
  't-mobile.cz',
  't-mobile-infra.cz',
  'telekom-digital.com',
  'businesspartner.t-mobile.at',
  'external.t-mobile.at',
  'magenta.atmagenta-infra.at',
  'cosmote-evalue.gr',
  'cosmotepayments.gr',
  'cosmoteshops.gr',
  'c-ts.grevalue.gr',
  'germanos.gr',
  'groupnet.grote.gr',
  'oteacademy.gr',
  'oteasfalisi.gr',
  'ote-estate.gr',
  'cosmote-gs.com',
  'oteplc.co.uk',
  'telekom.mk',
  'external.telekom.me',
  'telekom.me',
  'iskon.hr',
  't.ht.hr',
  'mobile.telekom.ro',
  'telekom.ro',
  'congstar.net',
  'buyin.pro',
  'detecon.com',
  't-systems.com',
  'pan-net.eu',
  'telekom.com',
  'telekom.de',
  'external.telekom.de',
  'titaniumplatform.com',
  'amalitech.com',
  'ote.gr',
];

export default allowedDomains;
